const menu = {
  namespaced: true,
  state: {
    // menuList: [

    //   // {
    //   //   path: "/overview",
    //   //   title: "总览",
    //   //   icon: require("@/assets/images/overview.png"),
    //   //   iconActive: require("@/assets/images/overview-active.png"),
    //   //   submenu: false,
    //   // },
    //   {
    //     path: "/LargeDataScreen",
    //     title: "数据大屏1",
    //     icon: require("@/assets/images/saving.png"),
    //     iconActive: require("@/assets/images/saving-active.png"),
    //     meta: {
    //       title: "数据大屏",
    //       requiredPermissions: ["data_large_screen_menu"],
    //       showInSidebar: true
    //     },
    //     submenu: [
    //       { path: "/LargeDataScreen/IncomeData", title: "收益数据大屏" ,
    //         meta: {
    //           title: "收益数据大屏",
    //           requiredPermissions: ["earn_data_large_screen_menu"],
    //           showInSidebar: true
    //         },
    //       },
    //       {
    //         path: "/LargeDataScreen/EnergyUseData",
    //         title: "用能数据大屏",
    //         meta: {
    //           title: "用能数据大屏",
    //           requiredPermissions: ["energy_data_large_screen_menu"],
    //           showInSidebar: true
    //         },
    //       },
    //     ],
    //   },
    //   {
    //     path: "/RealTimeMonitoring",
    //     title: "实时监测",
    //     icon: require("@/assets/images/overview.png"),
    //     iconActive: require("@/assets/images/overview-active.png"),
    //     meta: {
    //       title: "实时监测",
    //       requiredPermissions: ["real_time_monitor_menu"],
    //       showInSidebar: true
    //     },
    //     submenu: false,
    //   },
    //   {
    //     path: "/ReportCenter",
    //     title: "报表中心",
    //     icon: require("@/assets/images/baobiao.png"),
    //     iconActive: require("@/assets/images/baobiao-active.png"),
    //     meta: {
    //       title: "报表中心",
    //       requiredPermissions: ["roport_menu"],
    //       showInSidebar: true
    //     },
    //     submenu: [
    //       { path: "/ReportCenter/SettlementStatement", title: "结算清单",
    //         meta: {
    //           title: "结算清单",
    //           requiredPermissions: ["settle_menu"],
    //           showInSidebar: true
    //         },
    //        },
    //       {
    //         path: "/ReportCenter/EnergySavingDetails",
    //         title: "节能明细",
    //         meta: {
    //           title: "节能明细",
    //           requiredPermissions: ["earn_detail_menu"],
    //           showInSidebar: true
    //         },
    //       },
    //     ],
    //   },
    //   {
    //     path: "/MotorAssets",
    //     title: "电机资产",
    //     icon: require("@/assets/images/dianjiZC.png"),
    //     iconActive: require("@/assets/images/dianjiZC-active.png"),
    //     meta: {
    //       title: "电机资产",
    //       requiredPermissions: ["asset_manage_menu"],
    //       showInSidebar: true
    //     },
    //     submenu: [
    //       { path: "/MotorAssets/MotorAssets", title: "电机资产" ,
    //         meta: {
    //           title: "电机资产",
    //           requiredPermissions: ["device_asset_menu"],
    //           showInSidebar: true
    //         },
    //       },
    //       { path: "/MotorAssets/CustomerProfile", title: "客户档案",
    //         meta: {
    //           title: "客户档案",
    //           requiredPermissions: ["customer_menu"],
    //           showInSidebar: true
    //         },
    //        },
    //       {
    //         path: "/MotorAssets/ElectricityPriceAllocation",
    //         title: "电价配置",
    //         meta: {
    //           title: "电价配置",
    //           requiredPermissions: ["priceSetting_menu"],
    //           showInSidebar: true
    //         },
    //       },
    //       {
    //         path: "/MotorAssets/AllocationSharingRules",
    //         title: "分成规则配置",
    //         meta: {
    //           title: "分成规则配置",
    //           requiredPermissions: ["earn_rule_menu"],
    //           showInSidebar: true
    //         },
    //       },
    //       { path: "/MotorAssets/ItemList", title: "项目清单",
    //         meta: {
    //           title: "项目清单",
    //           requiredPermissions: ["project_menu"],
    //           showInSidebar: true
    //         },
    //        },
    //     ],
    //   },
    //   // {
    //   //   path: "/EnergySavingAnalysis",
    //   //   title: "节能分析",
    //   //   icon: require("@/assets/images/overview.png"),
    //   //   iconActive: require("@/assets/images/overview-active.png"),
    //   //   submenu: false,
    //   // },
    //   // {
    //   //   path: "/energySavingBenefits",
    //   //   title: "节能收益",
    //   //   icon: require("@/assets/images/saving.png"),
    //   //   iconActive: require("@/assets/images/saving-active.png"),
    //   //   submenu: [
    //   //     { path: "/energySavingBenefits/settlementList", title: "结算清单" },
    //   //     {
    //   //       path: "/energySavingBenefits/energySavingDetails",
    //   //       title: "节能明细",
    //   //     },
    //   //   ],
    //   // },
    //   // {
    //   //   path: "/motorManagement",
    //   //   title: "电机管理",
    //   //   icon: require("@/assets/images/menu-motor.png"),
    //   //   iconActive: require("@/assets/images/menu-motor-active.png"),
    //   //   submenu: [
    //   //     { path: "/motorManagement/motorControl", title: "电机控制" },
    //   //     // {
    //   //     //   path: "/motorManagement/energyConservation",
    //   //     //   title: "电机节能收益",
    //   //     //   submenu: [
    //   //     //     {
    //   //     //       path: "/motorManagement/energyConservation/settlementDoc",
    //   //     //       title: "结算清单",
    //   //     //     },
    //   //     //     {
    //   //     //       path: "/motorManagement/energyConservation/settlementDetails",
    //   //     //       title: "节能明细",
    //   //     //     },
    //   //     //   ],
    //   //     // },
    //   //   ],
    //   // },
    //   // {
    //   //   path: "/intelligence",
    //   //   title: "智能运维",
    //   //   icon: require("@/assets/images/options.png"),
    //   //   iconActive: require("@/assets/images/options-active.png"),
    //   //   submenu: [
    //   //     { path: "/intelligence/repairOrder", title: "维修清单" },
    //   //     { path: "/intelligence/alarmLog", title: "告警记录" },
    //   //   ],
    //   // },
    //   {
    //     path: "/basic",
    //     title: "基础配置",
    //     icon: require("@/assets/images/basic.png"),
    //     iconActive: require("@/assets/images/basic-active.png"),
    //       meta: {
    //           title: "基础配置",
    //           requiredPermissions: ["base_setting_menu"],
    //           showInSidebar: true
    //         },
    //     submenu: [
    //       // { path: "/basic/project", title: "项目清单" },
    //       // { path: "/basic/customer", title: "客户档案" },
    //       { path: "/basic/LabelConfiguration", title: "标签配置",
    //         meta: {
    //           title: "标签配置",
    //           requiredPermissions: ["label_menu"],
    //           showInSidebar: true
    //         },

    //        },
    //       { path: "/basic/motor", title: "电机档案",
    //         meta: {
    //           title: "电机档案",
    //           requiredPermissions: ["motor_type_menu"],
    //           showInSidebar: true
    //         },
    //        },
    //       // { path: "/basic/price", title: "电价配置" },
    //     ],
    //   },
    //   {
    //     path: "/platform",
    //     title: "平台管理",
    //     icon: require("@/assets/images/plateform.png"),
    //     iconActive: require("@/assets/images/plateform-active.png"),
    //     authority: "TENANT_ADMIN",
    //     meta: {
    //       title: "平台管理",
    //       requiredPermissions: ["platform_manage_menu"],
    //       showInSidebar: true
    //     },
    //     submenu: [
    //       { path: "/platform/organization", title: "组织管理",
    //         meta: {
    //           title: "组织管理",
    //           requiredPermissions: ["org_manage_menu"],
    //           showInSidebar: true
    //         },
    //        },
    //       { path: "/platform/UserManagement", title: "用户管理",
    //         meta: {
    //           title: "用户管理",
    //           requiredPermissions: ["user_manage_menu"],
    //           showInSidebar: true
    //         },
    //        },
    //       { path: "/platform/RoleManagement", title: "角色管理",
    //         meta: {
    //           title: "角色管理",
    //           requiredPermissions: ["user_role_manage_menu"],
    //           showInSidebar: true
    //         },
    //        },
    //       // { path: "5-4", title: "部门管理" },
    //     ],
    //   },

    // ],
    menuList: [],
    menuListCode: [],
    buttonList: [],
    currentTab: null,
    tabs: [],
    orgList: [], // 当前用户所在的组织
    customerInfo: {}, // 当前用户所属客户
    roleList: [], // 当前用户所拥有的角色
    userName:'',//用户名称
  },
  getters: {
    menuList: (state) => state.menuList,
    buttonList: (state) => state.buttonList,
    currentTab: (state) => state.currentTab,
    tabs: (state) => state.tabs
  },
  mutations: {
    SET_MENULIST(state, menuList) {
      state.menuList = menuList
    },
    SET_MENULIST_CODE(state, menuListCode) {
      state.menuListCode = menuListCode
    },
    SET_BUTTONLIST(state, buttonList) {
      state.buttonList = buttonList
    },
    SET_CURRENT_TAB(state, currentTab) {
      state.currentTab = currentTab
    },
    SET_TABS(state, tabs) {
      state.tabs = tabs
    },
    SET_ORG_LIST(state, orgList) {
      state.orgList = orgList
    },
    SET_CUSTOMER_INFO(state, customerInfo) {
      state.customerInfo = customerInfo
    },
    SET_ROLE_LIST(state, roleList) {
      state.roleList = roleList
    },
    SET_USER_NAME(state, userName) {
      state.userName = userName
    },
  },
  actions: {
    setMenuList({ commit }, menuList) {
      commit('SET_MENULIST', menuList)
    },
    setMenuListCode({ commit }, menuListCode) {
      commit('SET_MENULIST_CODE', menuListCode)
    },
    setButtonList({ commit }, buttonList) {
      commit('SET_BUTTONLIST', buttonList)
    },
    setCurrentTab({ commit }, currentTab) {
      commit('SET_CURRENT_TAB', currentTab)
    },
    setTabs({ commit }, tabs) {
      commit('SET_TABS', tabs)
    },
    setOrgList({ commit }, orgList) {
      commit('SET_ORG_LIST', orgList)
    },
    setCustomerInfo({ commit }, customerInfo) {
      commit('SET_CUSTOMER_INFO', customerInfo)
    },
    setRoleList({ commit }, roleList) {
      commit('SET_ROLE_LIST', roleList)
    },
    setUserName({ commit }, userName) {
      commit('SET_USER_NAME', userName)
    },
  }
}

export default menu
